<template>
  <div
    class="footer_wrap"
    :style="{
      background: isTheme ? '#303846' : '#303846',
      height:isTheme  ? '80px':'60px'
    }"
  >
    <div
      class="footer_inner"
      :style="{
        color: isTheme ? '#ffffff' : '#ffffff'
      }"
    >
      <div>
        AI智能体市场由 <a href="https://www.rainbond.com/feature/app-market">Rainstore</a> 驱动
        &nbsp;&nbsp;&nbsp;京ICP备15028663
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  props: {
    isTheme: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  data() {
    return {};
  }
};
</script>
<style scoped>
.footer_wrap {
  display: flex;
  width: 100%;
  height: 80px;
  align-items: center;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.2);
  z-index: 9999;
}
.footer_inner {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
}
.footer_inner div {
  font-family: PingFangSC-Light, helvetica neue, hiragino sans gb, arial,
    microsoft yahei ui, microsoft yahei, simsun, sans-serif;
  font-weight: 400;
  line-height: 36px;
}
.footer_inner div:last-child {
  margin-bottom: 0;
}
.footBox {
  background-color: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue